module.exports = __webpack_public_path__ + "img/parking-info-2@2x.dc6fda38.png";